/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Change_Field_Proposed_QtyInputs */

const en_po_change_field_proposed_qty = /** @type {(inputs: Po_Change_Field_Proposed_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposed quantity`)
};

/**
* | output |
* | --- |
* | "Proposed quantity" |
*
* @param {Po_Change_Field_Proposed_QtyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_change_field_proposed_qty = /** @type {((inputs?: Po_Change_Field_Proposed_QtyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Change_Field_Proposed_QtyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_change_field_proposed_qty(inputs)
});